import { c as _c } from "react/compiler-runtime";
import { memo, type PropsWithChildren } from 'react';
export interface VaultTransactionsLayoutProps extends PropsWithChildren {
  tableSettingsSlot?: React.ReactNode;
  title: string;
}
const VaultTransactionsLayout = t0 => {
  const $ = _c(8);
  const {
    children,
    tableSettingsSlot,
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <span className="text-foreground text-sm">{title}</span>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== tableSettingsSlot) {
    t2 = <div className="max-lg:gap-xs flex flex-row items-center justify-between max-lg:flex-col max-lg:items-start max-lg:justify-start">{t1}{tableSettingsSlot}</div>;
    $[2] = t1;
    $[3] = tableSettingsSlot;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children || $[6] !== t2) {
    t3 = <div className="gap-sm flex basis-[100%] flex-col">{t2}{children}</div>;
    $[5] = children;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default memo(VaultTransactionsLayout);